// extracted by mini-css-extract-plugin
export default {"scheduleSwither":"ScheduleToggler_scheduleSwither__pxaCe","scheduleSwither__button":"ScheduleToggler_scheduleSwither__button__JKcf+"};